import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgG1 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 34 80",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(2 25)",
		stroke: "#0D0E10",
		strokeWidth: 2,
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("rect", {
			x: -1,
			y: -1,
			width: 32,
			height: 32,
			rx: 1
		}), /* @__PURE__ */ _jsx("path", { d: "M19.5-1v7c0 .552-.224 1.052-.586 1.414A1.994 1.994 0 0117.5 8h0-5a1.994 1.994 0 01-1.414-.586A1.994 1.994 0 0110.5 6h0v-7h9z" })]
	})
});
export default SvgG1;
